import { combineReducers } from 'redux';
import { userReducer } from './users/userReducer.ts';
import { scenarioReducer } from './scenarios/scenarioReducer.ts';
import { guiStateReducer } from './guiState/guiStateReducer.ts';
import { userManagementReducer } from './userManagement/userManagementReducer.ts';
import { scenarioChartReducer } from './scenarios/scenarioChartReducer.ts';
import { intentClipboardReducer } from './scenarios/intentClipboard/index.ts';
import { audioReducer } from './audio/audioReducer.ts';
import { VoiceRecognitionReducer } from './recognition/VoiceRecognitionReducer.ts';
import { dialogProcessorReducer } from './dialogProcess/dialogProcessorReducer.ts';
import { companyReducer } from '../reducers/companyManagment/companyReducer.ts';
import { dashboardReducer } from '../reducers/dashboard/dashboardReducer.ts';
import { snackBarElementsReducer } from '../reducers/snackBarElements/snackBarElements.ts';
import { groupManagementSlice } from 'app/components/GroupManagement/store/groupManagementSlice.ts';
import courseManagementReducer, {
  courseManagementSlice
} from 'app/components/CourseManagement/store/courseManagementReducer.ts';
import globalAssetsLibrarySlice from 'app/store/GlobalAssetsLibrary/globalAssetsLibrarySlice.ts';
import callManagementSlice from 'app/components/CallManagement/store/callManagementSlice.ts';
import { departmentReducer } from './companyManagment/departmentReducer.ts';
import { translatorSlice } from 'app/components/Translator/store/translatorSlice.ts';
import { scenarioPlayerSlice } from 'app/components/ScenarioPlayerPage/store/scenarioPlayerSlice.ts';
import { audioChatSlice } from 'app/store/AudioChat/audioChatSlice.ts';

export const rootReducer = combineReducers({
  scenarioReducer,
  scenarioChartReducer,
  userReducer,
  guiStateReducer,
  audioReducer,
  voiceRecognitionReducer: VoiceRecognitionReducer,
  userManagementReducer,
  dialogProcessorReducer,
  companyReducer,
  dashboardReducer,
  intentClipboardReducer,
  snackBarElements: snackBarElementsReducer,
  translator: translatorSlice.reducer,
  scenarioPlayer: scenarioPlayerSlice.reducer,
  audioChat: audioChatSlice.reducer,
  department: departmentReducer,  // Changed to match selector's expected state shape
  groupManagement: groupManagementSlice.reducer,
  [courseManagementSlice.name]: courseManagementReducer,
  [globalAssetsLibrarySlice.name]: globalAssetsLibrarySlice.reducer,
  [callManagementSlice.name]: callManagementSlice.reducer
});

export type RootState = ReturnType<typeof rootReducer>;
